import { ComponentProps } from "react";
import styled from "styled-components";
import { staticText } from "../../shared/statics/static-text";
import {
  minMedium,
  semanticAmber,
  semanticBlue,
  semanticGreen,
  semanticRed01,
  shade0,
  shade900,
} from "../../styles/tokens";
import { Body } from "../body/Body";

export enum StatusChipVariant {
  Active = "active",
  Pending = "pending",
  Inactive = "inactive",
  InPerpetuity = "inPerpetuity",
}

// TEXT
export const text = staticText.statusChip;

// STYLES
export const Text = styled(Body).attrs({
  variant: "normal-strong",
  tag: "div",
})`
  padding: 0 0 0.1875rem;
`;

export const Chip = styled.span<ChipProps>`
  display: flex;
  width: max-content;
  align-items: center;
  gap: 0.5rem;
  border-radius: 2rem;
  height: 2rem;
  padding: 0 0.75rem;

  color: ${({ $variant }) =>
    $variant === StatusChipVariant.InPerpetuity ? shade900 : shade0};
  background-color: ${({ $variant }) => {
    if ($variant === StatusChipVariant.InPerpetuity) {
      return semanticBlue;
    } else if ($variant === StatusChipVariant.Active) {
      return semanticGreen;
    } else if ($variant === StatusChipVariant.Pending) {
      return semanticAmber;
    } else {
      return semanticRed01;
    }
  }};

  &:has(> svg:only-child) {
    padding: 0;
    width: 1.5rem;
    height: 1.5rem;
    justify-content: center;

    @media ${minMedium} {
      width: 2rem;
      height: 2rem;
    }
  }

  > svg {
    width: 0.625rem;

    @media ${minMedium} {
      width: 0.75rem;
    }
  }
`;

export const ChipSkeleton = styled(Chip)`
  &::after {
    border-radius: 2rem;
  }
`;

// DATA

// TYPES
export type Props = ComponentProps<"span"> & {
  /** What kind of information does this status chip indicate? */
  variant?: StatusChipVariant;
  /** Override for status text if provided */
  label?: string;
  /** Use icon only variant */
  iconOnly?: boolean;
};

type ChipProps = {
  $variant?: StatusChipVariant;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
